import React from 'react'
import {Container} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import './style.css'

export default function index() {
    return (
        <Container className="akun-berberkah">
            <h5>Akun</h5>
            <div className="content-akun">
                {
                    ItemAkun.map((data, i) => {
                        return (
                                <Link key={i} className={`account-data ${data.cLink}`} to={data.link}>
                                    <p>{data.name}</p>
                                    <img src="asset/users/right.svg" alt="right" />
                                </Link>
                        )
                    })
                }
            </div>
        </Container>
    )
}

const ItemAkun = [
    {name:"Akun Saya", link:"ber_account", cLink:"border-bottom"},{name:"Transaksi Saya", link:"ber_transaksi", cLink:"border-bottom"},{name:"Alamat Pengiriman", link:"ber_alamat"}
]